import { render } from "./KitVimeoPlayer.vue?vue&type=template&id=10cdc46f"
import script from "./KitVimeoPlayer.vue?vue&type=script&lang=js"
export * from "./KitVimeoPlayer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vote.gikit.ru/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__